import { TFunction } from "i18next";
import { FilterContexType } from "../../../../components/layout/ViewHeader";
import { RootCauseCardType, RootCauseMenuSection } from "../../../../features/dataInsights/DataInsightsRootCause/data";
import { FiltersRegistry } from "../../types";
import { getMenuAvailableFilters, getMenuConfigurations, getMenuSavedFilters } from "../menuSelectors";

export const getRootCauseMenuSections = (
	registry: FiltersRegistry | null,
	cardType: RootCauseCardType,
	t: TFunction,
	params?: {
		visibility?: FilterContexType;
		search?: string;
	}
): RootCauseMenuSection[] => {
	if (cardType === "perimeter") {
		return [
			{
				id: "available",
				title: t("other filters"),
				items: getMenuAvailableFilters(registry, params),
			},
		];
	}

	return [
		{
			id: "saved",
			title: t("saved filters"),
			items: getMenuSavedFilters(registry, params),
		},
		{
			id: "available",
			title: t("other filters"),
			items: getMenuAvailableFilters(registry, params),
		},
		{
			id: "configurations",
			title: t("configurations"),
			items: getMenuConfigurations(registry, params),
		},
	];
};
